import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './en.json';
import idTranslations from './id.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      id: { translation: idTranslations }
    },
    lng: 'id', // Default language
    fallbackLng: 'id', // Fallback language if a translation is missing
    interpolation: {
      escapeValue: false // React already escapes the values
    }
  });

export default i18n;
